module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-3-photo-4-aea1b30805cb5514b79dd1f7d089326e.webp";